import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Forma, Datos, TareaSincronizada, DatosSincronizacion } from '@app/shared';

@Injectable()
export class DynamicFormsDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta la forma de la tarea
   *
   * @param {number} idForm
   * @returns {Observable<Forma>}
   * @memberof DynamicFormsDataService
   */
  getForm(idForm: number): Observable<Forma> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<Forma>(this.api.get('dynamicForm', [idForm])).subscribe(
        form => {
          form.sub_formas.sort((a, b) => a.orden - b.orden);
          form.sub_formas.forEach(subForm => {
            subForm.campos.sort((a, b) => a.orden - b.orden);
          });
          obs.next(form);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Guarda los datos de la forma
   *
   * @param {number} idTask
   * @param {Array<Datos>} data
   * @param {*} dataTable
   * @returns {Observable<boolean>}
   * @memberof DynamicFormsDataService
   */
  saveDatos(
    idTask: number,
    data: Array<Datos>,
    dataTable: any,
    saveMunicipality: any
  ): Observable<boolean> {
    return new Observable(obs => {
      const formData = {tarea: idTask, datos: data, tabla_datos: dataTable};
      if (saveMunicipality) {
        formData['guardar_municipio'] = saveMunicipality;
      }
      this.http.skipErrorHandler().post(this.api.get('dynamicFormInstance'), formData).subscribe(
        form => {
          obs.next(true);
          this.toastr.success('Guardado correctamente', 'Operacion exitosa');
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          obs.error(err);
        }
      );
    });
  }

  /**
   * Retorna las formas de la tarea y las tareas asociadas con los campos que se deben sincronizar
   *
   * @param {number} idTask
   * @returns {Observable<TareaSincronizada>}
   * @memberof DynamicFormsDataService
   */
  getFormTaskSync(idTask: number): Promise<TareaSincronizada[]> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
      .get<TareaSincronizada[]>(this.api.get('synchronizationForms', [idTask])).subscribe(
        form => {
          resolve(form);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Sincroniza los formulario y tablas con las otras tareas
   *
   * @param {DatosSincronizacion} dataSync
   * @returns {Promise<boolean>}
   * @memberof DynamicFormsDataService
   */
  syncFormTask(dataSync: DatosSincronizacion): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
      .post<boolean>(this.api.get('synchronizationForms'), dataSync).subscribe(
        resp => {
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Registrar los consecutivos seleccionados al expediente actual
   *
   * @param {number[]} consecutives
   * @param {number} idTask
   * @returns {Promise<boolean>}
   * @memberof DynamicFormsDataService
   */
  registerConsecutive(consecutives: number[], idTask: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const formData = {
        id_tarea: idTask,
        consecutivos: consecutives
      };
      this.http.skipErrorHandler()
      .post<boolean>(this.api.get('consecutiveActDocument'), formData).subscribe(
        resp => {
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/all/dynamic-forms/shared/dynamic-forms-data.service.ts